import WhyOneMindFrame from "@/components/whyOneMind";
import { TRUST_FACTORS } from "./constants";

const TrustFactors = () => {
  return <WhyOneMindFrame {...TRUST_FACTORS} />;
};

export default TrustFactors;
